module.exports = __webpack_public_path__ + "img/fairgreen.142021e0.png";